import React, { memo } from 'react';
import { CDropdown, CDropdownItem, CDropdownMenu, CDropdownToggle } from '@coreui/react';
import CIcon from '@coreui/icons-react';
import { useSelector } from 'react-redux';

import { logoutUser } from '../../core/helpers/auth';
import useGlobalSelectionsContext from '../../core/hooks/useGlobalSelectionsContext';

const ToggleDropdown = () => {
  const {
    user: { email },
  } = useSelector((state) => state.auth.auth) ?? '';
  const { isPetitionImageViewerUser, isPetitionUploaderUser, isCanvassingOrganizationUserUser, isReportViewerUser } =
    useGlobalSelectionsContext();

  const onLogout = () => logoutUser();

  return (
    <CDropdown className="px-3 d-lg-flex align-items-center">
      <CDropdownToggle
        className="rounded-circle m-1"
        variant="outline"
        caret={false}
        dusk="toggle-user-dropdown"
        data-test-id="toggle-user-dropdown"
      >
        <CIcon name="cil-user" size="lg" className="text-center" alt="CoreUI Icons User" />
      </CDropdownToggle>

      <CDropdownMenu>
        {email && <CDropdownItem disabled>{email}</CDropdownItem>}
        {/* Do not show settings to users with limited page access */}
        {!isPetitionImageViewerUser && !isPetitionUploaderUser && !isReportViewerUser && !isCanvassingOrganizationUserUser && (
          <CDropdownItem to="/settings-page">
            <CIcon name="cil-settings" className="mr-2" alt="CoreUI Icons Settings" />
            Settings
          </CDropdownItem>
        )}
        <CDropdownItem onClick={onLogout} data-test-id="logout-link">
          <CIcon name="cil-account-logout" className="mr-2" alt="CoreUI Icons Logout" />
          Logout
        </CDropdownItem>
      </CDropdownMenu>
    </CDropdown>
  );
};

export default memo(ToggleDropdown);
